import React from "react";

// Единый блок пустого состояния: заголовок + пояснение.
// Используется диаграммами, перечнем и сводной таблицей (RQ.22.09).
export default function EmptyState({ title, desc, icon }) {
  return (
    <div className="vsu-empty">
      {icon ? <div className="vsu-empty-ic">{icon}</div> : null}
      <b>{title}</b>
      {desc ? <div>{desc}</div> : null}
    </div>
  );
}
